module.exports = __webpack_public_path__ + "d849999aa3cbd1665a2a07483b0c98af.png";